import { useEffect, useState } from 'react'
import { apiEtapa3 } from '../api'
import Aviso from '../../components/Aviso'
import { competenciaAtual, moeda } from '../../components/format'
import { Campo } from '../../etapa2/componentes'

const FAIXAS_ANS = [[0, 18], [19, 23], [24, 28], [29, 33], [34, 38], [39, 43], [44, 48], [49, 53], [54, 58], [59, null]]

export default function Planos({ empresaId }) {
  const [operadoras, setOperadoras] = useState([])
  const [tabelas, setTabelas] = useState([])
  const [erro, setErro] = useState('')
  const [ok, setOk] = useState('')
  const [op, setOp] = useState({ cnpj: '', nome: '', registro_ans: '' })
  const [tab, setTab] = useState({ operadora_id: '', nome_plano: '', tipo: 'SAUDE', vigencia_inicio: competenciaAtual(), valores: FAIXAS_ANS.map(() => '') })
  const [ad, setAd] = useState({ funcionario_id: 'F1', tabela_id: '', cpf: '', nome: '', nascimento: '', dependentes: '', pct_tit: '30', pct_dep: '50', inicio: competenciaAtual() })
  const [imp, setImp] = useState({ operadora_id: '', competencia: competenciaAtual(), arquivo: null })
  const [competencia, setCompetencia] = useState(competenciaAtual())
  const [mensalidades, setMensalidades] = useState(null)
  const [importacao, setImportacao] = useState(null)

  const recarregar = () => Promise.all([apiEtapa3.operadoras(), apiEtapa3.tabelas()]).then(([o, t]) => { setOperadoras(o); setTabelas(t) }).catch((e) => setErro(e.message))
  useEffect(() => { recarregar() }, [])

  async function executar(acao, mensagem) {
    setErro('')
    setOk('')
    try {
      const r = await acao()
      if (mensagem) setOk(mensagem)
      await recarregar()
      return r
    } catch (e) {
      setErro(e.message)
    }
  }

  const salvarOperadora = () => executar(() => apiEtapa3.criarOperadora(op), 'Operadora cadastrada.')
  const salvarTabela = () =>
    executar(() => apiEtapa3.criarTabela({
      operadora_id: tab.operadora_id, nome_plano: tab.nome_plano, tipo: tab.tipo, vigencia_inicio: tab.vigencia_inicio,
      faixas: FAIXAS_ANS.map(([min, max], i) => ({ idade_min: min, idade_max: max, valor: tab.valores[i] || '0' })),
    }), 'Tabela de preços cadastrada.')
  const salvarAdesao = () =>
    executar(() => apiEtapa3.criarAdesao({
      empresa_id: empresaId, funcionario_id: ad.funcionario_id, tabela_id: ad.tabela_id, inicio: ad.inicio,
      titular: { cpf: ad.cpf, nome: ad.nome, data_nascimento: ad.nascimento },
      // uma linha por dependente: CPF; nome; AAAA-MM-DD; tipo (Tabela 07)
      dependentes: ad.dependentes.split('\n').filter((l) => l.trim()).map((l) => {
        const [cpf, nome, data_nascimento, tipo_dependente] = l.split(';').map((s) => s.trim())
        return { cpf, nome, data_nascimento, tipo_dependente: tipo_dependente || null }
      }),
      percentual_desconto_titular: ad.pct_tit, percentual_desconto_dependentes: ad.pct_dep,
    }), 'Adesão registrada.')
  async function importar() {
    const texto = await imp.arquivo.arrayBuffer()
    const r = await executar(() => apiEtapa3.importarCoparticipacao(empresaId, imp.operadora_id, imp.competencia, texto))
    if (r) setImportacao(r)
  }
  const carregarMensalidades = () => executar(() => apiEtapa3.mensalidades(empresaId, competencia)).then((r) => r && setMensalidades(r))

  return (
    <section>
      <h2>Planos de saúde e odontológico</h2>
      <Aviso>{erro}</Aviso>
      <Aviso tipo="ok">{ok}</Aviso>

      <h3>Operadora</h3>
      <div className="grade">
        <Campo rotulo="CNPJ"><input value={op.cnpj} onChange={(e) => setOp({ ...op, cnpj: e.target.value })} /></Campo>
        <Campo rotulo="Nome"><input value={op.nome} onChange={(e) => setOp({ ...op, nome: e.target.value })} /></Campo>
        <Campo rotulo="Registro ANS"><input value={op.registro_ans} onChange={(e) => setOp({ ...op, registro_ans: e.target.value })} /></Campo>
      </div>
      <div className="acoes"><button onClick={salvarOperadora}>Cadastrar operadora</button></div>

      <h3>Tabela de preços por faixa etária</h3>
      <div className="grade">
        <Campo rotulo="Operadora">
          <select value={tab.operadora_id} onChange={(e) => setTab({ ...tab, operadora_id: e.target.value })}>
            <option value="">Selecione</option>
            {operadoras.map((o) => <option key={o.operadora_id} value={o.operadora_id}>{o.nome}</option>)}
          </select>
        </Campo>
        <Campo rotulo="Plano"><input value={tab.nome_plano} onChange={(e) => setTab({ ...tab, nome_plano: e.target.value })} /></Campo>
        <Campo rotulo="Tipo">
          <select value={tab.tipo} onChange={(e) => setTab({ ...tab, tipo: e.target.value })}><option value="SAUDE">Saúde</option><option value="ODONTO">Odontológico</option></select>
        </Campo>
        <Campo rotulo="Vigência"><input type="month" value={tab.vigencia_inicio} onChange={(e) => setTab({ ...tab, vigencia_inicio: e.target.value })} /></Campo>
        {FAIXAS_ANS.map(([min, max], i) => (
          <Campo key={min} rotulo={max === null ? `${min} anos ou mais` : `${min} a ${max} anos`}>
            <input type="number" step="0.01" value={tab.valores[i]} onChange={(e) => setTab({ ...tab, valores: tab.valores.map((v, j) => (j === i ? e.target.value : v)) })} />
          </Campo>
        ))}
      </div>
      <div className="acoes"><button onClick={salvarTabela}>Cadastrar tabela</button></div>

      <h3>Adesão do funcionário</h3>
      <div className="grade">
        <Campo rotulo="Matrícula"><input value={ad.funcionario_id} onChange={(e) => setAd({ ...ad, funcionario_id: e.target.value })} /></Campo>
        <Campo rotulo="Tabela">
          <select value={ad.tabela_id} onChange={(e) => setAd({ ...ad, tabela_id: e.target.value })}>
            <option value="">Selecione</option>
            {tabelas.map((t) => <option key={t.tabela_id} value={t.tabela_id}>{t.nome_plano} ({t.tipo.toLowerCase()})</option>)}
          </select>
        </Campo>
        <Campo rotulo="CPF do titular"><input value={ad.cpf} onChange={(e) => setAd({ ...ad, cpf: e.target.value })} /></Campo>
        <Campo rotulo="Nome do titular"><input value={ad.nome} onChange={(e) => setAd({ ...ad, nome: e.target.value })} /></Campo>
        <Campo rotulo="Nascimento"><input type="date" value={ad.nascimento} onChange={(e) => setAd({ ...ad, nascimento: e.target.value })} /></Campo>
        <Campo rotulo="% descontado do titular"><input type="number" value={ad.pct_tit} onChange={(e) => setAd({ ...ad, pct_tit: e.target.value })} /></Campo>
        <Campo rotulo="% descontado por dependente"><input type="number" value={ad.pct_dep} onChange={(e) => setAd({ ...ad, pct_dep: e.target.value })} /></Campo>
        <Campo rotulo="Início"><input type="month" value={ad.inicio} onChange={(e) => setAd({ ...ad, inicio: e.target.value })} /></Campo>
      </div>
      <Campo rotulo="Dependentes (um por linha: CPF; nome; AAAA-MM-DD; tipo eSocial)">
        <textarea rows="3" value={ad.dependentes} onChange={(e) => setAd({ ...ad, dependentes: e.target.value })} />
      </Campo>
      <div className="acoes"><button disabled={!empresaId} onClick={salvarAdesao}>Registrar adesão</button></div>

      <h3>Importar coparticipação (CSV da operadora)</h3>
      <p className="fundamento">Colunas: cpf; data_atendimento; valor; descricao (opcional). Separador ; ou , e valores com vírgula decimal.</p>
      <div className="grade">
        <Campo rotulo="Operadora">
          <select value={imp.operadora_id} onChange={(e) => setImp({ ...imp, operadora_id: e.target.value })}>
            <option value="">Selecione</option>
            {operadoras.map((o) => <option key={o.operadora_id} value={o.operadora_id}>{o.nome}</option>)}
          </select>
        </Campo>
        <Campo rotulo="Competência"><input type="month" value={imp.competencia} onChange={(e) => setImp({ ...imp, competencia: e.target.value })} /></Campo>
        <Campo rotulo="Arquivo CSV"><input type="file" accept=".csv,text/csv" onChange={(e) => setImp({ ...imp, arquivo: e.target.files[0] })} /></Campo>
      </div>
      <div className="acoes"><button disabled={!empresaId || !imp.arquivo || !imp.operadora_id} onClick={importar}>Importar</button></div>
      {importacao && (
        <div className={`aviso aviso-${importacao.erros.length ? 'erro' : 'ok'}`}>
          {importacao.lancadas} de {importacao.linhas_lidas} linhas lançadas ({moeda(importacao.total_lancado)}).
          {importacao.erros.length > 0 && <ul>{importacao.erros.map((e) => <li key={e}>{e}</li>)}</ul>}
        </div>
      )}

      <h3>Descontos do mês</h3>
      <div className="acoes">
        <label className="inline">Competência <input type="month" value={competencia} onChange={(e) => setCompetencia(e.target.value)} /></label>
        <button className="secundario" disabled={!empresaId} onClick={carregarMensalidades}>Calcular</button>
      </div>
      {mensalidades && (
        <table>
          <thead><tr><th>Matrícula</th><th>Beneficiário</th><th>Idade</th><th className="num">Custo</th><th className="num">Desconto</th><th className="num">Coparticipação</th></tr></thead>
          <tbody>
            {mensalidades.flatMap((m) => m.beneficiarios.map((b) => (
              <tr key={m.adesao_id + b.cpf}>
                <td>{m.funcionario_id}</td><td>{b.nome}{b.titular ? ' (titular)' : ''}</td><td>{b.idade}</td>
                <td className="num">{moeda(b.custo_total)}</td><td className="num">{moeda(b.desconto_funcionario)}</td><td className="num">{moeda(b.coparticipacao)}</td>
              </tr>
            )))}
          </tbody>
        </table>
      )}
    </section>
  )
}
